import React, {FC} from 'react';
import {useNavigate} from 'react-router-dom';
import {useMutation} from '@apollo/client';
import dayjs from 'dayjs';

import {LossInput} from '../../__generated__/global-types';
import FormLayout from '../../components/FormLayout/FormLayout';
import { LOSS_SUCCESS } from '../../config/routes';
import {createLoss, createLossVariables} from '../../shared/graphql/__generated__/createLoss';
import {CREATE_LOSS} from '../../shared/graphql/createLoss';
import {Contacts} from '../index/Contacts/Contacts';

import image from './loss.svg';
import LossForm from './LossForm';


const Loss: FC = () => {

    const navigate = useNavigate();
    const [createLoss] = useMutation<createLoss,createLossVariables>(CREATE_LOSS)

    const onComplete = async (data:LossInput) => {
        await createLoss({
            variables: {data: {...data, Certificate_Date: dayjs(data.Certificate_Date).format('YYYY-MM-DD')}},
            onCompleted: () => {
                navigate(LOSS_SUCCESS)
            }
        })
    }

    return (
        <div>
            <div className={'content'}>
                {/*<Banners/>*/}
            </div>

            <FormLayout image={image}>
                <h2>Заявить убыток</h2>
                <LossForm onComplete={onComplete}/>
            </FormLayout>

            <div className={'content'}>
                <Contacts/>
            </div>
        </div>
    );
}

export default Loss;



